import Router from "./Navigation/Router";
import Navigator from "./Navigation/Navigator";

function App() {
  return (
    <>
      <Navigator />
      <Router />
    </>
  );
}

export default App;
